import { useEffect, useRef } from 'react';
import { useSocketContext } from '../contexts/SocketContext';
import { getConfig, isWidgetConfig } from '../../config';
export const useSocketConnection = () => {
    const { socket, connectionUsersCount } = useSocketContext();
    const disconnectTimeoutID = useRef();
    useEffect(() => {
        const connectToSocket = () => {
            const config = getConfig();
            if (isWidgetConfig(config) && config.identityType === 'guest') {
                return;
            }
            if (disconnectTimeoutID.current) {
                // Cancel disconnect if it was scheduled
                window.clearTimeout(disconnectTimeoutID.current);
            }
            if (
            // we may need to check closing state here as well
            !socket.isConnected() &&
                socket.connectionState() !== 'connecting') {
                void socket.connect();
            }
            connectionUsersCount.current += 1;
        };
        const disconnectFromSocket = () => {
            // Cancel disconnect if it was scheduled
            if (disconnectTimeoutID.current) {
                window.clearTimeout(disconnectTimeoutID.current);
            }
            connectionUsersCount.current -= 1;
            // Schedule disconnect if no users are connected
            disconnectTimeoutID.current = window.setTimeout(() => {
                if (connectionUsersCount.current === 0 &&
                    socket.isConnected() &&
                    socket.connectionState() !== 'closing') {
                    socket.disconnect();
                }
            }, 5000);
        };
        connectToSocket();
        return disconnectFromSocket;
    }, [connectionUsersCount, socket]);
    return socket;
};
//# sourceMappingURL=useSocketConnection.js.map